import React, { useState } from 'react'
import icon from '../../../../assets/recovery-convert.png'
import CustomInput from '../../../../components/CustomInputs/CustomInput'
import { Button, Spinner } from 'flowbite-react'
import client from '../../../../api/client'
import showToast from '../../../../components/CustomToast/toastHelper'

interface RefundProps{
    transaction:any
    close:()=>void
}
const RefundCustomer = ({transaction, close}:RefundProps) => {
    const [amount, setAmount] = useState<string>(transaction.amount);
    const [reason, setReason] = useState<string>('')
    const [loading, setLoading] = useState<boolean>(false)
    const disableFunction = () => {
        return !(amount);
    };

    const disabled = disableFunction()
    const dataToSend:any = []

    const refund =async() =>{
        setLoading(true)
        const data ={
            amount:transaction.amount,
            reason:reason,
            transactionReference: transaction.orderReference
        }

        const payload = [...dataToSend, data]
        try {
            const response = await client.post('/subsidiary/dashboard/refund',payload);
            const message = response?.data?.message;
            showToast(message,"success")
            close()
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
        finally{
            setLoading(false)
        }
    }
    return (
        <div>
            <div>
                <img src={icon} className='my-3' alt="icon" />
                <div className='my-3'>
                    <p className='text-xl font-bold'>Refund customer</p>
                </div>
                <div>
                    <p className='font-semibold'>Transaction Amount : {transaction.amount}</p>
                    <div>
                        <CustomInput label='Amount to refund' name='amount' value={amount}  onChange={e=> setAmount(e.target.value)}/>
                    </div>
                    <div>
                        <CustomInput label='Reason' name='reason' value={reason}  onChange={e=> setReason(e.target.value)}/>
                    </div>
                    <div className='flex gap-4'>
                        <Button className='w-1/4' outline onClick={()=>close()}>Cancel</Button>
                        <Button
                            className={`w-3/4 text-black ${disabled ? 'bg-gray-400 cursor-not-allowed' : 'bg-custom-button-green'}`}
                            disabled={disabled} onClick={() => refund()}
                        >
                            {loading ? <Spinner /> :'Refund Customer'}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RefundCustomer
